import type { WorkItemRelation } from '../../types'

export { type WorkItemRelation } from '../../types'

export const IWorkItemRelationService = Symbol('IWorkItemRelationService')

export interface IWorkItemRelationService {
  // observable 属性
  relationList: WorkItemRelation[];
  isFetchingRelationList: boolean;

  getAll(projectKey: string): Promise<WorkItemRelation[]>;
}
